import type { SearchKeywordData } from '../../../services/analyticsApi';

interface SearchKeywordsListProps {
  data: SearchKeywordData[];
}

const SearchKeywordsList: React.FC<SearchKeywordsListProps> = ({ data }) => {
  return (
    <div style={{ background: 'white', border: '1px solid #ddd', borderRadius: 8, padding: 16 }}>
      <h3 style={{ fontSize: 16, fontWeight: 500, color: '#333', marginBottom: 12 }}>搜尋關鍵字</h3>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {data.map((item, index) => (
          <li key={index} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
            <span style={{ fontSize: 14, color: '#333' }}>{item.keyword}</span>
            <span style={{ fontSize: 12, color: '#999' }}>{item.count} 次</span>
          </li>
        ))}
        {data.length === 0 && <li style={{ padding: 20, textAlign: 'center', color: '#999' }}>沒有資料</li>}
      </ul>
    </div>
  );
};

export default SearchKeywordsList;
